// AUPRÉA — constantes partagées (intégration, contrats, cotisation) : module sans dépendance pour éviter les imports circulaires
export const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";
export const hdrs = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("auprea_token")}` } });
export const TEAL = "#1F7A6C", OR = "#C8902C", ROUGE = "#B42318";
export const fr = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR") : "");
export const errMsg = (e) => e?.response?.data?.detail || "Erreur";
